module.exports = __webpack_public_path__ + "static/media/kv-all-premium-casino.89f3158c.jpeg";